import { Button } from "@/components/ui/button";
import React, { useMemo, useState } from "react";

type HeaderRender = (args: {
  more: boolean;
  toggle: () => void;
  setMore: React.Dispatch<React.SetStateAction<boolean>>;
}) => React.ReactNode;

export const ViewMore = ({
  children,
  header,
  isViewMore,
  defaultOpen = false,
}: {
  children: React.ReactNode;
  header: React.ReactNode | HeaderRender;
  isViewMore: boolean;
  defaultOpen?: boolean;
}) => {
  const [more, setMore] = useState<boolean>(defaultOpen);
  const toggle = () => setMore((m) => !m);

  const renderedHeader = useMemo(
    () =>
      typeof header === "function"
        ? (header as HeaderRender)({ more, toggle, setMore })
        : header,
    [header, more]
  );

  return (
    <>
      {renderedHeader}
      {more ? children : null}
      {isViewMore ? (
        <Button
          variant="ghost"
          className="w-full h-auto py-1 px-1 text-primary text-left justify-center hover:bg-white text-xs"
          onClick={toggle}
        >
          {more ? "View Less" : "View More..."}
        </Button>
      ) : null}
    </>
  );
};

// import { Button } from "@/components/ui/button";
// import React, { useState } from "react";

// export const ViewMore = ({
//   children,
//   header,
//   isViewMore,
// }: {
//   children: React.ReactNode;
//   header: React.ReactNode;
//   isViewMore: boolean;
// }) => {
//   const [more, setMore] = useState(false);
//   return (
//     <>
//       {header}
//       {more ? children : null}
//       {isViewMore ? (
//         <Button
//           variant={"ghost"}
//           className="w-[120px]  h-auto py-1 px-1 text-primary text-left justify-start text-xs "
//           onClick={() => setMore(!more)}
//         >
//           {more ? "View Less" : "View More..."}
//         </Button>
//       ) : (
//         ""
//       )}
//     </>
//   );
// };
